//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  Observable,
  from as _observableFrom,
  of as _observableOf,
  throwError as _observableThrow,
} from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

import { UsertStore } from '../context/userStore';
import { GATEWAY_API_BASE_URL } from './mhsGatewayApiTokens';

@Injectable({
  providedIn: 'root',
})
export class MhsConfigurationApiClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  private http = inject(HttpClient);
  private userStore = inject(UsertStore);
  private baseUrl = inject(GATEWAY_API_BASE_URL, { optional: true });
  /**
   * @param tenant_name (optional) name of tenant
   * @param subId (optional) subId of the user
   * @param modules (optional) modules of the user
   * @param tenants_access (optional) tenants of the user
   * @param body (optional)
   * @return OK
   */

  protected transformOptions(options: any): Promise<any> {
    options.headers = options.headers.append(
      'tenant-name',
      this.userStore.currentTenant()?.tenantName,
    );
    return Promise.resolve(options);
  }
  /**
   * @return OK
   */
  application_GetContext(httpContext?: HttpContext): Observable<ApplicationContext> {
    let url_ = this.baseUrl + '/gateway/configuration/application/context';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApplication_GetContext(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApplication_GetContext(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApplicationContext>;
            }
          } else return _observableThrow(response_) as any as Observable<ApplicationContext>;
        }),
      );
  }

  protected processApplication_GetContext(
    response: HttpResponseBase,
  ): Observable<ApplicationContext> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationContext.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  application_GetCompanyStructure(httpContext?: HttpContext): Observable<CompanyStructure> {
    let url_ = this.baseUrl + '/gateway/configuration/application/company-structure';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApplication_GetCompanyStructure(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApplication_GetCompanyStructure(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompanyStructure>;
            }
          } else return _observableThrow(response_) as any as Observable<CompanyStructure>;
        }),
      );
  }

  protected processApplication_GetCompanyStructure(
    response: HttpResponseBase,
  ): Observable<CompanyStructure> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompanyStructure.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  bodyArea_GetAll(httpContext?: HttpContext): Observable<BodyAreaCodeDto[]> {
    let url_ = this.baseUrl + '/gateway/configuration/body-area';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBodyArea_GetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBodyArea_GetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BodyAreaCodeDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<BodyAreaCodeDto[]>;
        }),
      );
  }

  protected processBodyArea_GetAll(response: HttpResponseBase): Observable<BodyAreaCodeDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BodyAreaCodeDto.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param year (optional)
   * @return OK
   */
  calendar_GetPublicHolidays(
    year: number | undefined,
    httpContext?: HttpContext,
  ): Observable<PublicHolidayDto[]> {
    let url_ = this.baseUrl + '/gateway/configuration/calendar/public-holidays?';
    if (year === null) throw new globalThis.Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'year=' + encodeURIComponent('' + year) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCalendar_GetPublicHolidays(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCalendar_GetPublicHolidays(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PublicHolidayDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PublicHolidayDto[]>;
        }),
      );
  }

  protected processCalendar_GetPublicHolidays(
    response: HttpResponseBase,
  ): Observable<PublicHolidayDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PublicHolidayDto.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  dequeueReason_Get(httpContext?: HttpContext): Observable<DequeueReasonDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/dequeue-reason';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDequeueReason_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDequeueReason_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<DequeueReasonDropDownItem[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<DequeueReasonDropDownItem[]>;
        }),
      );
  }

  protected processDequeueReason_Get(
    response: HttpResponseBase,
  ): Observable<DequeueReasonDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(DequeueReasonDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  entry_Get(httpContext?: HttpContext): Observable<Entry[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEntry_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEntry_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Entry[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Entry[]>;
        }),
      );
  }

  protected processEntry_Get(response: HttpResponseBase): Observable<Entry[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Entry.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param scope (optional)
   * @return OK
   */
  entry_GetByScope(scope: string | undefined, httpContext?: HttpContext): Observable<Entry[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/query?';
    if (scope === null) throw new globalThis.Error("The parameter 'scope' cannot be null.");
    else if (scope !== undefined) url_ += 'scope=' + encodeURIComponent('' + scope) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEntry_GetByScope(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEntry_GetByScope(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Entry[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Entry[]>;
        }),
      );
  }

  protected processEntry_GetByScope(response: HttpResponseBase): Observable<Entry[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Entry.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param scope (optional)
   * @param phrase (optional)
   * @param top (optional)
   * @return OK
   */
  entry_GetByScopeAndPhrase(
    scope: string | undefined,
    phrase: string | undefined,
    top: number | undefined,
    httpContext?: HttpContext,
  ): Observable<Entry[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/query/phrase?';
    if (scope === null) throw new globalThis.Error("The parameter 'scope' cannot be null.");
    else if (scope !== undefined) url_ += 'scope=' + encodeURIComponent('' + scope) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'phrase=' + encodeURIComponent('' + phrase) + '&';
    if (top === null) throw new globalThis.Error("The parameter 'top' cannot be null.");
    else if (top !== undefined) url_ += 'top=' + encodeURIComponent('' + top) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEntry_GetByScopeAndPhrase(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEntry_GetByScopeAndPhrase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Entry[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Entry[]>;
        }),
      );
  }

  protected processEntry_GetByScopeAndPhrase(response: HttpResponseBase): Observable<Entry[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Entry.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param voivod (optional)
   * @param county (optional)
   * @param commune (optional)
   * @return OK
   */
  geoCode_GetTerritory(
    voivod: string | undefined,
    county: string | undefined,
    commune: string | undefined,
    httpContext?: HttpContext,
  ): Observable<TerritoryCodeDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/geo-code/territory/query?';
    if (voivod === null) throw new globalThis.Error("The parameter 'voivod' cannot be null.");
    else if (voivod !== undefined) url_ += 'voivod=' + encodeURIComponent('' + voivod) + '&';
    if (county === null) throw new globalThis.Error("The parameter 'county' cannot be null.");
    else if (county !== undefined) url_ += 'county=' + encodeURIComponent('' + county) + '&';
    if (commune === null) throw new globalThis.Error("The parameter 'commune' cannot be null.");
    else if (commune !== undefined) url_ += 'commune=' + encodeURIComponent('' + commune) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeoCode_GetTerritory(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeoCode_GetTerritory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TerritoryCodeDropDownItem[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<TerritoryCodeDropDownItem[]>;
        }),
      );
  }

  protected processGeoCode_GetTerritory(
    response: HttpResponseBase,
  ): Observable<TerritoryCodeDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(TerritoryCodeDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param zip (optional)
   * @return OK
   */
  geoCode_GetZip(
    zip: string | undefined,
    httpContext?: HttpContext,
  ): Observable<ZipCodeDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/geo-code/zip/query?';
    if (zip === null) throw new globalThis.Error("The parameter 'zip' cannot be null.");
    else if (zip !== undefined) url_ += 'zip=' + encodeURIComponent('' + zip) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeoCode_GetZip(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeoCode_GetZip(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ZipCodeDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ZipCodeDropDownItem[]>;
        }),
      );
  }

  protected processGeoCode_GetZip(response: HttpResponseBase): Observable<ZipCodeDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ZipCodeDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param zip (optional)
   * @return OK
   */
  geoCode_GetDistinctZip(
    zip: string | undefined,
    httpContext?: HttpContext,
  ): Observable<ZipCodeDistinctDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/geo-code/zip/query-distinct?';
    if (zip === null) throw new globalThis.Error("The parameter 'zip' cannot be null.");
    else if (zip !== undefined) url_ += 'zip=' + encodeURIComponent('' + zip) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeoCode_GetDistinctZip(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeoCode_GetDistinctZip(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ZipCodeDistinctDropDownItem[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ZipCodeDistinctDropDownItem[]>;
        }),
      );
  }

  protected processGeoCode_GetDistinctZip(
    response: HttpResponseBase,
  ): Observable<ZipCodeDistinctDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ZipCodeDistinctDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param icdCode (optional)
   * @return OK
   */
  icdCode_Get(icdCode: IcdCodeType | undefined, httpContext?: HttpContext): Observable<IcdCode[]> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code?';
    if (icdCode === null) throw new globalThis.Error("The parameter 'icdCode' cannot be null.");
    else if (icdCode !== undefined) url_ += 'icdCode=' + encodeURIComponent('' + icdCode) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCode[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IcdCode[]>;
        }),
      );
  }

  protected processIcdCode_Get(response: HttpResponseBase): Observable<IcdCode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IcdCode.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param icdCode (optional)
   * @param phrase (optional)
   * @param top (optional)
   * @return OK
   */
  icdCode_GetByPhrase(
    icdCode: IcdCodeType | undefined,
    phrase: string | undefined,
    top: number | undefined,
    httpContext?: HttpContext,
  ): Observable<IcdCodeItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/query/phrase?';
    if (icdCode === null) throw new globalThis.Error("The parameter 'icdCode' cannot be null.");
    else if (icdCode !== undefined) url_ += 'icdCode=' + encodeURIComponent('' + icdCode) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'phrase=' + encodeURIComponent('' + phrase) + '&';
    if (top === null) throw new globalThis.Error("The parameter 'top' cannot be null.");
    else if (top !== undefined) url_ += 'top=' + encodeURIComponent('' + top) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_GetByPhrase(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_GetByPhrase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCodeItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IcdCodeItem[]>;
        }),
      );
  }

  protected processIcdCode_GetByPhrase(response: HttpResponseBase): Observable<IcdCodeItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IcdCodeItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param icdCode (optional)
   * @param id (optional)
   * @return OK
   */
  icdCode_GetById(
    icdCode: IcdCodeType | undefined,
    id: number | undefined,
    httpContext?: HttpContext,
  ): Observable<IcdCodeItem> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/query/id?';
    if (icdCode === null) throw new globalThis.Error("The parameter 'icdCode' cannot be null.");
    else if (icdCode !== undefined) url_ += 'icdCode=' + encodeURIComponent('' + icdCode) + '&';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_GetById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_GetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCodeItem>;
            }
          } else return _observableThrow(response_) as any as Observable<IcdCodeItem>;
        }),
      );
  }

  protected processIcdCode_GetById(response: HttpResponseBase): Observable<IcdCodeItem> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IcdCodeItem.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param icdCode (optional)
   * @param code (optional)
   * @return OK
   */
  icdCode_GetByCode(
    icdCode: IcdCodeType | undefined,
    code: string | undefined,
    httpContext?: HttpContext,
  ): Observable<IcdCodeItem> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/query/code?';
    if (icdCode === null) throw new globalThis.Error("The parameter 'icdCode' cannot be null.");
    else if (icdCode !== undefined) url_ += 'icdCode=' + encodeURIComponent('' + icdCode) + '&';
    if (code === null) throw new globalThis.Error("The parameter 'code' cannot be null.");
    else if (code !== undefined) url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_GetByCode(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_GetByCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCodeItem>;
            }
          } else return _observableThrow(response_) as any as Observable<IcdCodeItem>;
        }),
      );
  }

  protected processIcdCode_GetByCode(response: HttpResponseBase): Observable<IcdCodeItem> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IcdCodeItem.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  icdCode_Add(
    body: AddIcdCodeWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<IcdCodeItem> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/add';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_Add(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_Add(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCodeItem>;
            }
          } else return _observableThrow(response_) as any as Observable<IcdCodeItem>;
        }),
      );
  }

  protected processIcdCode_Add(response: HttpResponseBase): Observable<IcdCodeItem> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IcdCodeItem.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  icdCode_Verify(
    body: VerifyIcdCodeWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/verify';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_Verify(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_Verify(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processIcdCode_Verify(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  icdCode_SetMetaEntry(
    body: SetIcdCodeMetaEntryWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/meta-entry';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_SetMetaEntry(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_SetMetaEntry(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processIcdCode_SetMetaEntry(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param icdCodeType (optional)
   * @param phrase (optional)
   * @param isVerified (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  icdCode_Search(
    icdCodeType: IcdCodeType | undefined,
    phrase: string | undefined,
    isVerified: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<IcdCodeHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/configuration/icd-code/search?';
    if (icdCodeType === null)
      throw new globalThis.Error("The parameter 'icdCodeType' cannot be null.");
    else if (icdCodeType !== undefined)
      url_ += 'IcdCodeType=' + encodeURIComponent('' + icdCodeType) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (isVerified === null)
      throw new globalThis.Error("The parameter 'isVerified' cannot be null.");
    else if (isVerified !== undefined)
      url_ += 'IsVerified=' + encodeURIComponent('' + isVerified) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIcdCode_Search(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIcdCode_Search(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IcdCodeHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<IcdCodeHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processIcdCode_Search(
    response: HttpResponseBase,
  ): Observable<IcdCodeHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IcdCodeHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  identifier_GetPaymentType(httpContext?: HttpContext): Observable<IdentifierDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/payment-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdentifier_GetPaymentType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdentifier_GetPaymentType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentifierDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentifierDropDownItem[]>;
        }),
      );
  }

  protected processIdentifier_GetPaymentType(
    response: HttpResponseBase,
  ): Observable<IdentifierDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IdentifierDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  identifier_GetIdentityType(httpContext?: HttpContext): Observable<IdentifierDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/identity-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdentifier_GetIdentityType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdentifier_GetIdentityType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentifierDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentifierDropDownItem[]>;
        }),
      );
  }

  protected processIdentifier_GetIdentityType(
    response: HttpResponseBase,
  ): Observable<IdentifierDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IdentifierDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  identifier_GetNhfQueueStateType(httpContext?: HttpContext): Observable<IdentifierDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/Nhf-queue-state-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdentifier_GetNhfQueueStateType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdentifier_GetNhfQueueStateType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentifierDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentifierDropDownItem[]>;
        }),
      );
  }

  protected processIdentifier_GetNhfQueueStateType(
    response: HttpResponseBase,
  ): Observable<IdentifierDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IdentifierDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  identifier_GetExamStateType(httpContext?: HttpContext): Observable<IdentifierDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/exam-state-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdentifier_GetExamStateType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdentifier_GetExamStateType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentifierDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentifierDropDownItem[]>;
        }),
      );
  }

  protected processIdentifier_GetExamStateType(
    response: HttpResponseBase,
  ): Observable<IdentifierDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IdentifierDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  identifier_GetAdmissionModeType(httpContext?: HttpContext): Observable<IdentifierDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/entry/admission-mode-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdentifier_GetAdmissionModeType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdentifier_GetAdmissionModeType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentifierDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentifierDropDownItem[]>;
        }),
      );
  }

  protected processIdentifier_GetAdmissionModeType(
    response: HttpResponseBase,
  ): Observable<IdentifierDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IdentifierDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param unitId (optional)
   * @param divisionId (optional)
   * @param type (optional)
   * @param phrase (optional)
   * @param top (optional)
   * @return OK
   */
  medServices_GetAll(
    unitId: string | undefined,
    divisionId: string | undefined,
    type: string | undefined,
    phrase: string | undefined,
    top: number | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service?';
    if (unitId === null) throw new globalThis.Error("The parameter 'unitId' cannot be null.");
    else if (unitId !== undefined) url_ += 'unitId=' + encodeURIComponent('' + unitId) + '&';
    if (divisionId === null)
      throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
    else if (divisionId !== undefined)
      url_ += 'divisionId=' + encodeURIComponent('' + divisionId) + '&';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'phrase=' + encodeURIComponent('' + phrase) + '&';
    if (top === null) throw new globalThis.Error("The parameter 'top' cannot be null.");
    else if (top !== undefined) url_ += 'top=' + encodeURIComponent('' + top) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_GetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_GetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<MedServiceDropDownItem[]>;
        }),
      );
  }

  protected processMedServices_GetAll(
    response: HttpResponseBase,
  ): Observable<MedServiceDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(MedServiceDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param type (optional)
   * @param unitId (optional)
   * @param divisionId (optional)
   * @param deviceTypeCollection (optional)
   * @param phrase (optional)
   * @param withContrast (optional)
   * @param withSpine (optional)
   * @param withPrePostContrast (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  medServices_Query(
    type: string | undefined,
    unitId: string | undefined,
    divisionId: string | undefined,
    deviceTypeCollection: string | undefined,
    phrase: string | undefined,
    withContrast: string | undefined,
    withSpine: string | undefined,
    withPrePostContrast: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/query?';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (unitId === null) throw new globalThis.Error("The parameter 'unitId' cannot be null.");
    else if (unitId !== undefined) url_ += 'UnitId=' + encodeURIComponent('' + unitId) + '&';
    if (divisionId === null)
      throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
    else if (divisionId !== undefined)
      url_ += 'DivisionId=' + encodeURIComponent('' + divisionId) + '&';
    if (deviceTypeCollection === null)
      throw new globalThis.Error("The parameter 'deviceTypeCollection' cannot be null.");
    else if (deviceTypeCollection !== undefined)
      url_ += 'DeviceTypeCollection=' + encodeURIComponent('' + deviceTypeCollection) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (withContrast === null)
      throw new globalThis.Error("The parameter 'withContrast' cannot be null.");
    else if (withContrast !== undefined)
      url_ += 'WithContrast=' + encodeURIComponent('' + withContrast) + '&';
    if (withSpine === null) throw new globalThis.Error("The parameter 'withSpine' cannot be null.");
    else if (withSpine !== undefined)
      url_ += 'WithSpine=' + encodeURIComponent('' + withSpine) + '&';
    if (withPrePostContrast === null)
      throw new globalThis.Error("The parameter 'withPrePostContrast' cannot be null.");
    else if (withPrePostContrast !== undefined)
      url_ += 'WithPrePostContrast=' + encodeURIComponent('' + withPrePostContrast) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Query(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Query(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MedServiceHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processMedServices_Query(
    response: HttpResponseBase,
  ): Observable<MedServiceHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param type (optional)
   * @param unitId (optional)
   * @param divisionId (optional)
   * @param phrase (optional)
   * @param withContrast (optional)
   * @param withSpine (optional)
   * @param withPrePostContrast (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  medServices_Search(
    type: string | undefined,
    unitId: string | undefined,
    divisionId: string | undefined,
    phrase: string | undefined,
    withContrast: string | undefined,
    withSpine: string | undefined,
    withPrePostContrast: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/search?';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (unitId === null) throw new globalThis.Error("The parameter 'unitId' cannot be null.");
    else if (unitId !== undefined) url_ += 'UnitId=' + encodeURIComponent('' + unitId) + '&';
    if (divisionId === null)
      throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
    else if (divisionId !== undefined)
      url_ += 'DivisionId=' + encodeURIComponent('' + divisionId) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (withContrast === null)
      throw new globalThis.Error("The parameter 'withContrast' cannot be null.");
    else if (withContrast !== undefined)
      url_ += 'WithContrast=' + encodeURIComponent('' + withContrast) + '&';
    if (withSpine === null) throw new globalThis.Error("The parameter 'withSpine' cannot be null.");
    else if (withSpine !== undefined)
      url_ += 'WithSpine=' + encodeURIComponent('' + withSpine) + '&';
    if (withPrePostContrast === null)
      throw new globalThis.Error("The parameter 'withPrePostContrast' cannot be null.");
    else if (withPrePostContrast !== undefined)
      url_ += 'WithPrePostContrast=' + encodeURIComponent('' + withPrePostContrast) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Search(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Search(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MedServiceHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processMedServices_Search(
    response: HttpResponseBase,
  ): Observable<MedServiceHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param type (optional)
   * @param unitId (optional)
   * @param divisionId (optional)
   * @param deviceTypeCollection (optional)
   * @param phrase (optional)
   * @param withContrast (optional)
   * @param withSpine (optional)
   * @param withPrePostContrast (optional)
   * @return OK
   */
  medServices_Export(
    type: string | undefined,
    unitId: string | undefined,
    divisionId: string | undefined,
    deviceTypeCollection: string | undefined,
    phrase: string | undefined,
    withContrast: string | undefined,
    withSpine: string | undefined,
    withPrePostContrast: string | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/export?';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (unitId === null) throw new globalThis.Error("The parameter 'unitId' cannot be null.");
    else if (unitId !== undefined) url_ += 'UnitId=' + encodeURIComponent('' + unitId) + '&';
    if (divisionId === null)
      throw new globalThis.Error("The parameter 'divisionId' cannot be null.");
    else if (divisionId !== undefined)
      url_ += 'DivisionId=' + encodeURIComponent('' + divisionId) + '&';
    if (deviceTypeCollection === null)
      throw new globalThis.Error("The parameter 'deviceTypeCollection' cannot be null.");
    else if (deviceTypeCollection !== undefined)
      url_ += 'DeviceTypeCollection=' + encodeURIComponent('' + deviceTypeCollection) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (withContrast === null)
      throw new globalThis.Error("The parameter 'withContrast' cannot be null.");
    else if (withContrast !== undefined)
      url_ += 'WithContrast=' + encodeURIComponent('' + withContrast) + '&';
    if (withSpine === null) throw new globalThis.Error("The parameter 'withSpine' cannot be null.");
    else if (withSpine !== undefined)
      url_ += 'WithSpine=' + encodeURIComponent('' + withSpine) + '&';
    if (withPrePostContrast === null)
      throw new globalThis.Error("The parameter 'withPrePostContrast' cannot be null.");
    else if (withPrePostContrast !== undefined)
      url_ += 'WithPrePostContrast=' + encodeURIComponent('' + withPrePostContrast) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Export(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Export(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServices_Export(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param responseFile (optional)
   * @return OK
   */
  medServices_ParseFromFile(
    responseFile: FileParameter | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/parse-from-file';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (responseFile === null || responseFile === undefined)
      throw new globalThis.Error("The parameter 'responseFile' cannot be null.");
    else
      content_.append(
        'responseFile',
        responseFile.data,
        responseFile.fileName ? responseFile.fileName : 'responseFile',
      );

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_ParseFromFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_ParseFromFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServices_ParseFromFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  medServices_MergeToFile(
    body: MedServiceWithPricesWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/merge-to-file';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_MergeToFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_MergeToFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServices_MergeToFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServices_Get(id: number | undefined, httpContext?: HttpContext): Observable<MedServiceDto> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/by-id?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MedServiceDto>;
        }),
      );
  }

  protected processMedServices_Get(response: HttpResponseBase): Observable<MedServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  medServices_Add(
    body: AddMedServiceWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceDto> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/add';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Add(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Add(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MedServiceDto>;
        }),
      );
  }

  protected processMedServices_Add(response: HttpResponseBase): Observable<MedServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  medServices_Update(
    body: UpdateMedServiceWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceDto> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Update(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Update(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MedServiceDto>;
        }),
      );
  }

  protected processMedServices_Update(response: HttpResponseBase): Observable<MedServiceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServices_Hide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/hide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Hide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Hide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServices_Hide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServices_Unhide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service/unhide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServices_Unhide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServices_Unhide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServices_Unhide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServiceSets_Get(
    id: number | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceSetHeaderRowItem> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceSetHeaderRowItem>;
            }
          } else
            return _observableThrow(response_) as any as Observable<MedServiceSetHeaderRowItem>;
        }),
      );
  }

  protected processMedServiceSets_Get(
    response: HttpResponseBase,
  ): Observable<MedServiceSetHeaderRowItem> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceSetHeaderRowItem.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  medServiceSets_Create(
    body: MedServiceCreateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<number> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_Create(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_Create(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processMedServiceSets_Create(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param medServiceCollection (optional)
   * @return OK
   */
  medServiceSets_GetByMedServices(
    medServiceCollection: string | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceSetDropDownItem> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/by-med-services?';
    if (medServiceCollection === null)
      throw new globalThis.Error("The parameter 'medServiceCollection' cannot be null.");
    else if (medServiceCollection !== undefined)
      url_ += 'medServiceCollection=' + encodeURIComponent('' + medServiceCollection) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_GetByMedServices(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_GetByMedServices(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MedServiceSetDropDownItem>;
            }
          } else return _observableThrow(response_) as any as Observable<MedServiceSetDropDownItem>;
        }),
      );
  }

  protected processMedServiceSets_GetByMedServices(
    response: HttpResponseBase,
  ): Observable<MedServiceSetDropDownItem> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceSetDropDownItem.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param type (optional)
   * @param phrase (optional)
   * @param isMultiple (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  medServiceSets_Query(
    type: string | undefined,
    phrase: string | undefined,
    isMultiple: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<MedServiceSetHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/query?';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (isMultiple === null)
      throw new globalThis.Error("The parameter 'isMultiple' cannot be null.");
    else if (isMultiple !== undefined)
      url_ += 'IsMultiple=' + encodeURIComponent('' + isMultiple) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_Query(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_Query(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<MedServiceSetHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<MedServiceSetHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processMedServiceSets_Query(
    response: HttpResponseBase,
  ): Observable<MedServiceSetHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MedServiceSetHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return OK
   */
  medServiceSets_UpdateName(
    id: number | undefined,
    body: string | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/change-name?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_UpdateName(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_UpdateName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServiceSets_UpdateName(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return OK
   */
  medServiceSets_UpdateMetadata(
    id: number | undefined,
    body: MedServiceSetMetadataUpdateRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/metadata?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_UpdateMetadata(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_UpdateMetadata(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServiceSets_UpdateMetadata(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServiceSets_Hide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/hide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_Hide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_Hide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServiceSets_Hide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  medServiceSets_Unhide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/med-service-set/unhide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMedServiceSets_Unhide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMedServiceSets_Unhide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMedServiceSets_Unhide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param groupType (optional)
   * @return OK
   */
  nhfDataCode_Get(
    groupType: NhfDataCodeGroupType | undefined,
    httpContext?: HttpContext,
  ): Observable<NhfCode[]> {
    let url_ = this.baseUrl + '/gateway/configuration/nhf-code?';
    if (groupType === null) throw new globalThis.Error("The parameter 'groupType' cannot be null.");
    else if (groupType !== undefined)
      url_ += 'groupType=' + encodeURIComponent('' + groupType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processNhfDataCode_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processNhfDataCode_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NhfCode[]>;
            }
          } else return _observableThrow(response_) as any as Observable<NhfCode[]>;
        }),
      );
  }

  protected processNhfDataCode_Get(response: HttpResponseBase): Observable<NhfCode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(NhfCode.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  payer_Get(httpContext?: HttpContext): Observable<PayerDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/payer';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPayer_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPayer_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PayerDropDownItem[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PayerDropDownItem[]>;
        }),
      );
  }

  protected processPayer_Get(response: HttpResponseBase): Observable<PayerDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PayerDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  privildgedDocumentType_Get(httpContext?: HttpContext): Observable<PrivildgedDocumentType[]> {
    let url_ = this.baseUrl + '/gateway/configuration/privildged-document-type';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPrivildgedDocumentType_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPrivildgedDocumentType_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PrivildgedDocumentType[]>;
            }
          } else return _observableThrow(response_) as any as Observable<PrivildgedDocumentType[]>;
        }),
      );
  }

  protected processPrivildgedDocumentType_Get(
    response: HttpResponseBase,
  ): Observable<PrivildgedDocumentType[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PrivildgedDocumentType.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  rescheduleReason_Get(httpContext?: HttpContext): Observable<RescheduleReasonDropDownItem[]> {
    let url_ = this.baseUrl + '/gateway/configuration/reschedule-reason';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRescheduleReason_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRescheduleReason_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RescheduleReasonDropDownItem[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<RescheduleReasonDropDownItem[]>;
        }),
      );
  }

  protected processRescheduleReason_Get(
    response: HttpResponseBase,
  ): Observable<RescheduleReasonDropDownItem[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(RescheduleReasonDropDownItem.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  role_Get(httpContext?: HttpContext): Observable<Role[]> {
    let url_ = this.baseUrl + '/gateway/configuration/role';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRole_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRole_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Role[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Role[]>;
        }),
      );
  }

  protected processRole_Get(response: HttpResponseBase): Observable<Role[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Role.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  serviceProvider_Get(
    id: number | undefined,
    httpContext?: HttpContext,
  ): Observable<ServiceProviderDto> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ServiceProviderDto>;
        }),
      );
  }

  protected processServiceProvider_Get(response: HttpResponseBase): Observable<ServiceProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  serviceProvider_Add(
    body: AddServiceProviderWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<ServiceProviderDto> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider/add';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Add(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Add(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ServiceProviderDto>;
        }),
      );
  }

  protected processServiceProvider_Add(response: HttpResponseBase): Observable<ServiceProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  serviceProvider_Update(
    body: UpdateServiceProviderWebRequest | undefined,
    httpContext?: HttpContext,
  ): Observable<ServiceProviderDto> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider/update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('put', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Update(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Update(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ServiceProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ServiceProviderDto>;
        }),
      );
  }

  protected processServiceProvider_Update(
    response: HttpResponseBase,
  ): Observable<ServiceProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param type (optional)
   * @param phrase (optional)
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @param orderBy (optional)
   * @param isOrderByAsc (optional)
   * @return OK
   */
  serviceProvider_Search(
    type: string | undefined,
    phrase: string | undefined,
    pageIndex: number | undefined,
    pageSize: number | undefined,
    orderBy: string | undefined,
    isOrderByAsc: boolean | undefined,
    httpContext?: HttpContext,
  ): Observable<ServiceProviderHeaderRowItemSearchResult> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider/search?';
    if (type === null) throw new globalThis.Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'Type=' + encodeURIComponent('' + type) + '&';
    if (phrase === null) throw new globalThis.Error("The parameter 'phrase' cannot be null.");
    else if (phrase !== undefined) url_ += 'Phrase=' + encodeURIComponent('' + phrase) + '&';
    if (pageIndex === null) throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined)
      url_ += 'PageIndex=' + encodeURIComponent('' + pageIndex) + '&';
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'PageSize=' + encodeURIComponent('' + pageSize) + '&';
    if (orderBy === null) throw new globalThis.Error("The parameter 'orderBy' cannot be null.");
    else if (orderBy !== undefined) url_ += 'OrderBy=' + encodeURIComponent('' + orderBy) + '&';
    if (isOrderByAsc === null)
      throw new globalThis.Error("The parameter 'isOrderByAsc' cannot be null.");
    else if (isOrderByAsc !== undefined)
      url_ += 'IsOrderByAsc=' + encodeURIComponent('' + isOrderByAsc) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Search(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Search(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<ServiceProviderHeaderRowItemSearchResult>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<ServiceProviderHeaderRowItemSearchResult>;
        }),
      );
  }

  protected processServiceProvider_Search(
    response: HttpResponseBase,
  ): Observable<ServiceProviderHeaderRowItemSearchResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ServiceProviderHeaderRowItemSearchResult.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  serviceProvider_Hide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider/hide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Hide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Hide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processServiceProvider_Hide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return OK
   */
  serviceProvider_Unhide(id: number | undefined, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/gateway/configuration/service-provider/unhide?';
    if (id === null) throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({}),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('post', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processServiceProvider_Unhide(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processServiceProvider_Unhide(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processServiceProvider_Unhide(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  unit_GetAll(httpContext?: HttpContext): Observable<Unit[]> {
    let url_ = this.baseUrl + '/gateway/configuration/unit';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnit_GetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnit_GetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Unit[]>;
            }
          } else return _observableThrow(response_) as any as Observable<Unit[]>;
        }),
      );
  }

  protected processUnit_GetAll(response: HttpResponseBase): Observable<Unit[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(Unit.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  unit_Get(id: number, httpContext?: HttpContext): Observable<Unit> {
    let url_ = this.baseUrl + '/gateway/configuration/unit/{id}';
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnit_Get(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnit_Get(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<Unit>;
            }
          } else return _observableThrow(response_) as any as Observable<Unit>;
        }),
      );
  }

  protected processUnit_Get(response: HttpResponseBase): Observable<Unit> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = Unit.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return OK
   */
  unit_GetUnitHeaders(httpContext?: HttpContext): Observable<UnitHeader[]> {
    let url_ = this.baseUrl + '/gateway/configuration/unit/headers';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      context: httpContext,
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return _observableFrom(this.transformOptions(options_))
      .pipe(
        _observableMergeMap((transformedOptions_) => {
          return this.http.request('get', url_, transformedOptions_);
        }),
      )
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnit_GetUnitHeaders(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnit_GetUnitHeaders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UnitHeader[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UnitHeader[]>;
        }),
      );
  }

  protected processUnit_GetUnitHeaders(response: HttpResponseBase): Observable<UnitHeader[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UnitHeader.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export class AddIcdCodeWebRequest implements IAddIcdCodeWebRequest {
  type?: IcdCodeType;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: string | undefined;

  constructor(data?: IAddIcdCodeWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.code = _data['code'];
      this.name = _data['name'];
      this.isVerified = _data['isVerified'];
    }
  }

  static fromJS(data: any): AddIcdCodeWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddIcdCodeWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['code'] = this.code;
    data['name'] = this.name;
    data['isVerified'] = this.isVerified;
    return data;
  }
}

export interface IAddIcdCodeWebRequest {
  type?: IcdCodeType;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: string | undefined;
}

export class AddMedServiceWebRequest implements IAddMedServiceWebRequest {
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IAddMedServiceWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.name = _data['name'];
      this.icd9Code = _data['icd9Code'];
      this.code = _data['code'];
      this.bodyAreaCode = _data['bodyAreaCode'];
      this.nhfPoints = _data['nhfPoints'];
      this.withContrast = _data['withContrast'];
      this.withSpine = _data['withSpine'];
      this.withPrePostContrast = _data['withPrePostContrast'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): AddMedServiceWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddMedServiceWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['name'] = this.name;
    data['icd9Code'] = this.icd9Code;
    data['code'] = this.code;
    data['bodyAreaCode'] = this.bodyAreaCode;
    data['nhfPoints'] = this.nhfPoints;
    data['withContrast'] = this.withContrast;
    data['withSpine'] = this.withSpine;
    data['withPrePostContrast'] = this.withPrePostContrast;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IAddMedServiceWebRequest {
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class AddServiceProviderWebRequest implements IAddServiceProviderWebRequest {
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;

  constructor(data?: IAddServiceProviderWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.regon = _data['regon'];
      this.code = _data['code'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.taxId = _data['taxId'];
      this.phone = _data['phone'];
      this.zip = _data['zip'];
      this.place = _data['place'];
      this.street = _data['street'];
      this.registryNumber = _data['registryNumber'];
    }
  }

  static fromJS(data: any): AddServiceProviderWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AddServiceProviderWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['regon'] = this.regon;
    data['code'] = this.code;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['name'] = this.name;
    data['description'] = this.description;
    data['taxId'] = this.taxId;
    data['phone'] = this.phone;
    data['zip'] = this.zip;
    data['place'] = this.place;
    data['street'] = this.street;
    data['registryNumber'] = this.registryNumber;
    return data;
  }
}

export interface IAddServiceProviderWebRequest {
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;
}

export class ApplicationContext implements IApplicationContext {
  applicationName?: string | undefined;
  companyHeader?: CompanyHeader;
  units?: UnitHeader[] | undefined;

  constructor(data?: IApplicationContext) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.applicationName = _data['applicationName'];
      this.companyHeader = _data['companyHeader']
        ? CompanyHeader.fromJS(_data['companyHeader'])
        : (undefined as any);
      if (Array.isArray(_data['units'])) {
        this.units = [] as any;
        for (let item of _data['units']) this.units!.push(UnitHeader.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApplicationContext {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationContext();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['applicationName'] = this.applicationName;
    data['companyHeader'] = this.companyHeader ? this.companyHeader.toJSON() : (undefined as any);
    if (Array.isArray(this.units)) {
      data['units'] = [];
      for (let item of this.units) data['units'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IApplicationContext {
  applicationName?: string | undefined;
  companyHeader?: CompanyHeader;
  units?: UnitHeader[] | undefined;
}

export class BodyAreaCodeDto implements IBodyAreaCodeDto {
  code?: string | undefined;
  name?: string | undefined;

  constructor(data?: IBodyAreaCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): BodyAreaCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new BodyAreaCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['name'] = this.name;
    return data;
  }
}

export interface IBodyAreaCodeDto {
  code?: string | undefined;
  name?: string | undefined;
}

export class CompanyHeader implements ICompanyHeader {
  id?: number;
  name?: string | undefined;
  tenantName?: string | undefined;

  constructor(data?: ICompanyHeader) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.tenantName = _data['tenantName'];
    }
  }

  static fromJS(data: any): CompanyHeader {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyHeader();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['tenantName'] = this.tenantName;
    return data;
  }
}

export interface ICompanyHeader {
  id?: number;
  name?: string | undefined;
  tenantName?: string | undefined;
}

export class CompanyStructure implements ICompanyStructure {
  id?: number;
  name?: string | undefined;
  code?: string | undefined;
  countryCode?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  taxId?: string | undefined;
  regon?: string | undefined;
  regon14?: string | undefined;
  phone?: string | undefined;
  tenantName?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;
  oidNode?: string | undefined;
  units?: CompanyUnit[] | undefined;

  constructor(data?: ICompanyStructure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.code = _data['code'];
      this.countryCode = _data['countryCode'];
      this.zip = _data['zip'];
      this.city = _data['city'];
      this.street = _data['street'];
      this.houseNo = _data['houseNo'];
      this.flatNo = _data['flatNo'];
      this.taxId = _data['taxId'];
      this.regon = _data['regon'];
      this.regon14 = _data['regon14'];
      this.phone = _data['phone'];
      this.tenantName = _data['tenantName'];
      this.hL7IdentifierType = _data['hL7IdentifierType'];
      this.hL7IdentifierValue = _data['hL7IdentifierValue'];
      this.oidNode = _data['oidNode'];
      if (Array.isArray(_data['units'])) {
        this.units = [] as any;
        for (let item of _data['units']) this.units!.push(CompanyUnit.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompanyStructure {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyStructure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['code'] = this.code;
    data['countryCode'] = this.countryCode;
    data['zip'] = this.zip;
    data['city'] = this.city;
    data['street'] = this.street;
    data['houseNo'] = this.houseNo;
    data['flatNo'] = this.flatNo;
    data['taxId'] = this.taxId;
    data['regon'] = this.regon;
    data['regon14'] = this.regon14;
    data['phone'] = this.phone;
    data['tenantName'] = this.tenantName;
    data['hL7IdentifierType'] = this.hL7IdentifierType;
    data['hL7IdentifierValue'] = this.hL7IdentifierValue;
    data['oidNode'] = this.oidNode;
    if (Array.isArray(this.units)) {
      data['units'] = [];
      for (let item of this.units) data['units'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICompanyStructure {
  id?: number;
  name?: string | undefined;
  code?: string | undefined;
  countryCode?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  taxId?: string | undefined;
  regon?: string | undefined;
  regon14?: string | undefined;
  phone?: string | undefined;
  tenantName?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;
  oidNode?: string | undefined;
  units?: CompanyUnit[] | undefined;
}

export class CompanyUnit implements ICompanyUnit {
  id?: number;
  companyId?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  nameCode?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  phone?: string | undefined;
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;
  isReadOnly?: boolean;
  divisions?: CompanyUnitDivision[] | undefined;

  constructor(data?: ICompanyUnit) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.companyId = _data['companyId'];
      this.name = _data['name'];
      this.normalizedName = _data['normalizedName'];
      this.nameCode = _data['nameCode'];
      this.zip = _data['zip'];
      this.city = _data['city'];
      this.street = _data['street'];
      this.houseNo = _data['houseNo'];
      this.flatNo = _data['flatNo'];
      this.phone = _data['phone'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.themeInfo = _data['themeInfo'];
      this.description = _data['description'];
      this.hL7IdentifierType = _data['hL7IdentifierType'];
      this.hL7IdentifierValue = _data['hL7IdentifierValue'];
      this.isReadOnly = _data['isReadOnly'];
      if (Array.isArray(_data['divisions'])) {
        this.divisions = [] as any;
        for (let item of _data['divisions']) this.divisions!.push(CompanyUnitDivision.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompanyUnit {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyUnit();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['companyId'] = this.companyId;
    data['name'] = this.name;
    data['normalizedName'] = this.normalizedName;
    data['nameCode'] = this.nameCode;
    data['zip'] = this.zip;
    data['city'] = this.city;
    data['street'] = this.street;
    data['houseNo'] = this.houseNo;
    data['flatNo'] = this.flatNo;
    data['phone'] = this.phone;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['themeInfo'] = this.themeInfo;
    data['description'] = this.description;
    data['hL7IdentifierType'] = this.hL7IdentifierType;
    data['hL7IdentifierValue'] = this.hL7IdentifierValue;
    data['isReadOnly'] = this.isReadOnly;
    if (Array.isArray(this.divisions)) {
      data['divisions'] = [];
      for (let item of this.divisions)
        data['divisions'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICompanyUnit {
  id?: number;
  companyId?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  nameCode?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  phone?: string | undefined;
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;
  isReadOnly?: boolean;
  divisions?: CompanyUnitDivision[] | undefined;
}

export class CompanyUnitDivision implements ICompanyUnitDivision {
  id?: number;
  type?: string | undefined;
  unitId?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  icdCode7?: string | undefined;
  icdCode8?: string | undefined;
  placeCode?: string | undefined;
  procedureCode?: string | undefined;
  serviceCode?: string | undefined;
  serviceTypeCode?: string | undefined;
  hasServiceForChildren?: boolean;
  phone?: string | undefined;
  nhfScheduleId?: string | undefined;
  pacsWorkModeType?: number;
  pacsApplicationId?: string | undefined;
  footer?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;

  constructor(data?: ICompanyUnitDivision) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.unitId = _data['unitId'];
      this.name = _data['name'];
      this.normalizedName = _data['normalizedName'];
      this.icdCode7 = _data['icdCode7'];
      this.icdCode8 = _data['icdCode8'];
      this.placeCode = _data['placeCode'];
      this.procedureCode = _data['procedureCode'];
      this.serviceCode = _data['serviceCode'];
      this.serviceTypeCode = _data['serviceTypeCode'];
      this.hasServiceForChildren = _data['hasServiceForChildren'];
      this.phone = _data['phone'];
      this.nhfScheduleId = _data['nhfScheduleId'];
      this.pacsWorkModeType = _data['pacsWorkModeType'];
      this.pacsApplicationId = _data['pacsApplicationId'];
      this.footer = _data['footer'];
      this.hL7IdentifierType = _data['hL7IdentifierType'];
      this.hL7IdentifierValue = _data['hL7IdentifierValue'];
    }
  }

  static fromJS(data: any): CompanyUnitDivision {
    data = typeof data === 'object' ? data : {};
    let result = new CompanyUnitDivision();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['unitId'] = this.unitId;
    data['name'] = this.name;
    data['normalizedName'] = this.normalizedName;
    data['icdCode7'] = this.icdCode7;
    data['icdCode8'] = this.icdCode8;
    data['placeCode'] = this.placeCode;
    data['procedureCode'] = this.procedureCode;
    data['serviceCode'] = this.serviceCode;
    data['serviceTypeCode'] = this.serviceTypeCode;
    data['hasServiceForChildren'] = this.hasServiceForChildren;
    data['phone'] = this.phone;
    data['nhfScheduleId'] = this.nhfScheduleId;
    data['pacsWorkModeType'] = this.pacsWorkModeType;
    data['pacsApplicationId'] = this.pacsApplicationId;
    data['footer'] = this.footer;
    data['hL7IdentifierType'] = this.hL7IdentifierType;
    data['hL7IdentifierValue'] = this.hL7IdentifierValue;
    return data;
  }
}

export interface ICompanyUnitDivision {
  id?: number;
  type?: string | undefined;
  unitId?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  icdCode7?: string | undefined;
  icdCode8?: string | undefined;
  placeCode?: string | undefined;
  procedureCode?: string | undefined;
  serviceCode?: string | undefined;
  serviceTypeCode?: string | undefined;
  hasServiceForChildren?: boolean;
  phone?: string | undefined;
  nhfScheduleId?: string | undefined;
  pacsWorkModeType?: number;
  pacsApplicationId?: string | undefined;
  footer?: string | undefined;
  hL7IdentifierType?: string | undefined;
  hL7IdentifierValue?: string | undefined;
}

export class DequeueReasonDropDownItem implements IDequeueReasonDropDownItem {
  id?: number;
  code?: number;
  description?: string | undefined;

  constructor(data?: IDequeueReasonDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.code = _data['code'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): DequeueReasonDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new DequeueReasonDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['description'] = this.description;
    return data;
  }
}

export interface IDequeueReasonDropDownItem {
  id?: number;
  code?: number;
  description?: string | undefined;
}

export enum DeviceTypes {
  RTG = 'RTG',
  MRI = 'MRI',
  USG = 'USG',
  CT = 'CT',
  DM = 'DM',
  DXA = 'DXA',
  HQT = 'HQT',
}

export class DivisionHeader implements IDivisionHeader {
  id?: number;
  name?: string | undefined;
  deviceTypes?: DeviceTypes;
  hasNhfQueueAccess?: boolean;
  hasBookingConfig?: boolean;

  constructor(data?: IDivisionHeader) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.deviceTypes = _data['deviceTypes'];
      this.hasNhfQueueAccess = _data['hasNhfQueueAccess'];
      this.hasBookingConfig = _data['hasBookingConfig'];
    }
  }

  static fromJS(data: any): DivisionHeader {
    data = typeof data === 'object' ? data : {};
    let result = new DivisionHeader();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['deviceTypes'] = this.deviceTypes;
    data['hasNhfQueueAccess'] = this.hasNhfQueueAccess;
    data['hasBookingConfig'] = this.hasBookingConfig;
    return data;
  }
}

export interface IDivisionHeader {
  id?: number;
  name?: string | undefined;
  deviceTypes?: DeviceTypes;
  hasNhfQueueAccess?: boolean;
  hasBookingConfig?: boolean;
}

export class Entry implements IEntry {
  scope?: string | undefined;
  entryKey?: string | undefined;
  entryValue?: string | undefined;
  entryDefaultValue?: string | undefined;
  entryNormalizedValue?: string | undefined;

  constructor(data?: IEntry) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scope = _data['scope'];
      this.entryKey = _data['entryKey'];
      this.entryValue = _data['entryValue'];
      this.entryDefaultValue = _data['entryDefaultValue'];
      this.entryNormalizedValue = _data['entryNormalizedValue'];
    }
  }

  static fromJS(data: any): Entry {
    data = typeof data === 'object' ? data : {};
    let result = new Entry();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scope'] = this.scope;
    data['entryKey'] = this.entryKey;
    data['entryValue'] = this.entryValue;
    data['entryDefaultValue'] = this.entryDefaultValue;
    data['entryNormalizedValue'] = this.entryNormalizedValue;
    return data;
  }
}

export interface IEntry {
  scope?: string | undefined;
  entryKey?: string | undefined;
  entryValue?: string | undefined;
  entryDefaultValue?: string | undefined;
  entryNormalizedValue?: string | undefined;
}

export class IcdCode implements IIcdCode {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  metaJson?: string | undefined;
  modifiedByUserId?: string | undefined;
  modifiedByUser?: string | undefined;
  createdByUserId?: string | undefined;
  createdByUser?: string | undefined;
  modifyDate?: string | undefined;
  timeStamp?: string | undefined;

  constructor(data?: IIcdCode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.code = _data['code'];
      this.name = _data['name'];
      this.isVerified = _data['isVerified'];
      this.metaJson = _data['metaJson'];
      this.modifiedByUserId = _data['modifiedByUserId'];
      this.modifiedByUser = _data['modifiedByUser'];
      this.createdByUserId = _data['createdByUserId'];
      this.createdByUser = _data['createdByUser'];
      this.modifyDate = _data['modifyDate'];
      this.timeStamp = _data['timeStamp'];
    }
  }

  static fromJS(data: any): IcdCode {
    data = typeof data === 'object' ? data : {};
    let result = new IcdCode();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['name'] = this.name;
    data['isVerified'] = this.isVerified;
    data['metaJson'] = this.metaJson;
    data['modifiedByUserId'] = this.modifiedByUserId;
    data['modifiedByUser'] = this.modifiedByUser;
    data['createdByUserId'] = this.createdByUserId;
    data['createdByUser'] = this.createdByUser;
    data['modifyDate'] = this.modifyDate;
    data['timeStamp'] = this.timeStamp;
    return data;
  }
}

export interface IIcdCode {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  metaJson?: string | undefined;
  modifiedByUserId?: string | undefined;
  modifiedByUser?: string | undefined;
  createdByUserId?: string | undefined;
  createdByUser?: string | undefined;
  modifyDate?: string | undefined;
  timeStamp?: string | undefined;
}

export class IcdCodeHeaderRowItem implements IIcdCodeHeaderRowItem {
  position?: number;
  id?: number;
  icdCodeType?: IcdCodeType;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  modifiedByUserId?: string | undefined;
  modifiedByUser?: string | undefined;
  createdByUserId?: string | undefined;
  createdByUser?: string | undefined;
  modifyDate?: string | undefined;
  timeStamp?: string | undefined;

  constructor(data?: IIcdCodeHeaderRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.position = _data['position'];
      this.id = _data['id'];
      this.icdCodeType = _data['icdCodeType'];
      this.code = _data['code'];
      this.name = _data['name'];
      this.isVerified = _data['isVerified'];
      this.modifiedByUserId = _data['modifiedByUserId'];
      this.modifiedByUser = _data['modifiedByUser'];
      this.createdByUserId = _data['createdByUserId'];
      this.createdByUser = _data['createdByUser'];
      this.modifyDate = _data['modifyDate'];
      this.timeStamp = _data['timeStamp'];
    }
  }

  static fromJS(data: any): IcdCodeHeaderRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new IcdCodeHeaderRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['position'] = this.position;
    data['id'] = this.id;
    data['icdCodeType'] = this.icdCodeType;
    data['code'] = this.code;
    data['name'] = this.name;
    data['isVerified'] = this.isVerified;
    data['modifiedByUserId'] = this.modifiedByUserId;
    data['modifiedByUser'] = this.modifiedByUser;
    data['createdByUserId'] = this.createdByUserId;
    data['createdByUser'] = this.createdByUser;
    data['modifyDate'] = this.modifyDate;
    data['timeStamp'] = this.timeStamp;
    return data;
  }
}

export interface IIcdCodeHeaderRowItem {
  position?: number;
  id?: number;
  icdCodeType?: IcdCodeType;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  modifiedByUserId?: string | undefined;
  modifiedByUser?: string | undefined;
  createdByUserId?: string | undefined;
  createdByUser?: string | undefined;
  modifyDate?: string | undefined;
  timeStamp?: string | undefined;
}

export class IcdCodeHeaderRowItemSearchResult implements IIcdCodeHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: IcdCodeHeaderRowItem[] | undefined;

  constructor(data?: IIcdCodeHeaderRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results']) this.results!.push(IcdCodeHeaderRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): IcdCodeHeaderRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new IcdCodeHeaderRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IIcdCodeHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: IcdCodeHeaderRowItem[] | undefined;
}

export class IcdCodeItem implements IIcdCodeItem {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  meta?: { [key: string]: IcdCodeMeta[] } | undefined;

  constructor(data?: IIcdCodeItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.code = _data['code'];
      this.name = _data['name'];
      this.isVerified = _data['isVerified'];
      if (_data['meta']) {
        this.meta = {} as any;
        for (let key in _data['meta']) {
          if (_data['meta'].hasOwnProperty(key))
            (this.meta as any)![key] = _data['meta'][key]
              ? _data['meta'][key].map((i: any) => IcdCodeMeta.fromJS(i))
              : [];
        }
      }
    }
  }

  static fromJS(data: any): IcdCodeItem {
    data = typeof data === 'object' ? data : {};
    let result = new IcdCodeItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['name'] = this.name;
    data['isVerified'] = this.isVerified;
    if (this.meta) {
      data['meta'] = {};
      for (let key in this.meta) {
        if (this.meta.hasOwnProperty(key)) (data['meta'] as any)[key] = (this.meta as any)[key];
      }
    }
    return data;
  }
}

export interface IIcdCodeItem {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  isVerified?: boolean;
  meta?: { [key: string]: IcdCodeMeta[] } | undefined;
}

export class IcdCodeMeta implements IIcdCodeMeta {
  code?: string | undefined;
  name?: string | undefined;

  constructor(data?: IIcdCodeMeta) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): IcdCodeMeta {
    data = typeof data === 'object' ? data : {};
    let result = new IcdCodeMeta();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['name'] = this.name;
    return data;
  }
}

export interface IIcdCodeMeta {
  code?: string | undefined;
  name?: string | undefined;
}

export enum IcdCodeType {
  Icd7 = 'Icd7',
  Icd8 = 'Icd8',
  Icd9 = 'Icd9',
  Icd10 = 'Icd10',
}

export class IdentifierDropDownItem implements IIdentifierDropDownItem {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;

  constructor(data?: IIdentifierDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): IdentifierDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new IdentifierDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface IIdentifierDropDownItem {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
}

export class MedServiceCreateRequest implements IMedServiceCreateRequest {
  type?: DeviceTypes;
  name?: string | undefined;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
  medServicesIds?: number[] | undefined;

  constructor(data?: IMedServiceCreateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
      if (Array.isArray(_data['medServicesIds'])) {
        this.medServicesIds = [] as any;
        for (let item of _data['medServicesIds']) this.medServicesIds!.push(item);
      }
    }
  }

  static fromJS(data: any): MedServiceCreateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceCreateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['name'] = this.name;
    data['description'] = this.description;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    if (Array.isArray(this.medServicesIds)) {
      data['medServicesIds'] = [];
      for (let item of this.medServicesIds) data['medServicesIds'].push(item);
    }
    return data;
  }
}

export interface IMedServiceCreateRequest {
  type?: DeviceTypes;
  name?: string | undefined;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
  medServicesIds?: number[] | undefined;
}

export class MedServiceDropDownItem implements IMedServiceDropDownItem {
  id?: number;
  type?: string | undefined;
  name?: string | undefined;
  icd9Code?: string | undefined;
  bodyAreaCode?: string | undefined;
  bodyAreaName?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IMedServiceDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.icd9Code = _data['icd9Code'];
      this.bodyAreaCode = _data['bodyAreaCode'];
      this.bodyAreaName = _data['bodyAreaName'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): MedServiceDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['icd9Code'] = this.icd9Code;
    data['bodyAreaCode'] = this.bodyAreaCode;
    data['bodyAreaName'] = this.bodyAreaName;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IMedServiceDropDownItem {
  id?: number;
  type?: string | undefined;
  name?: string | undefined;
  icd9Code?: string | undefined;
  bodyAreaCode?: string | undefined;
  bodyAreaName?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class MedServiceDto implements IMedServiceDto {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IMedServiceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.icd9Code = _data['icd9Code'];
      this.code = _data['code'];
      this.bodyAreaCode = _data['bodyAreaCode'];
      this.nhfPoints = _data['nhfPoints'];
      this.withContrast = _data['withContrast'];
      this.withSpine = _data['withSpine'];
      this.withPrePostContrast = _data['withPrePostContrast'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): MedServiceDto {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['icd9Code'] = this.icd9Code;
    data['code'] = this.code;
    data['bodyAreaCode'] = this.bodyAreaCode;
    data['nhfPoints'] = this.nhfPoints;
    data['withContrast'] = this.withContrast;
    data['withSpine'] = this.withSpine;
    data['withPrePostContrast'] = this.withPrePostContrast;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IMedServiceDto {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class MedServiceHeaderRowItem implements IMedServiceHeaderRowItem {
  position?: number;
  isHidden?: boolean;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  id?: number;
  type?: string | undefined;
  name?: string | undefined;
  icd9Code?: string | undefined;
  bodyAreaCode?: string | undefined;
  bodyAreaName?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IMedServiceHeaderRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.position = _data['position'];
      this.isHidden = _data['isHidden'];
      this.withContrast = _data['withContrast'];
      this.withSpine = _data['withSpine'];
      this.withPrePostContrast = _data['withPrePostContrast'];
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.icd9Code = _data['icd9Code'];
      this.bodyAreaCode = _data['bodyAreaCode'];
      this.bodyAreaName = _data['bodyAreaName'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): MedServiceHeaderRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceHeaderRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['position'] = this.position;
    data['isHidden'] = this.isHidden;
    data['withContrast'] = this.withContrast;
    data['withSpine'] = this.withSpine;
    data['withPrePostContrast'] = this.withPrePostContrast;
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['icd9Code'] = this.icd9Code;
    data['bodyAreaCode'] = this.bodyAreaCode;
    data['bodyAreaName'] = this.bodyAreaName;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IMedServiceHeaderRowItem {
  position?: number;
  isHidden?: boolean;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  id?: number;
  type?: string | undefined;
  name?: string | undefined;
  icd9Code?: string | undefined;
  bodyAreaCode?: string | undefined;
  bodyAreaName?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class MedServiceHeaderRowItemSearchResult implements IMedServiceHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: MedServiceHeaderRowItem[] | undefined;

  constructor(data?: IMedServiceHeaderRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results']) this.results!.push(MedServiceHeaderRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MedServiceHeaderRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceHeaderRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IMedServiceHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: MedServiceHeaderRowItem[] | undefined;
}

export class MedServiceSetDropDownItem implements IMedServiceSetDropDownItem {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IMedServiceSetDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): MedServiceSetDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceSetDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['description'] = this.description;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IMedServiceSetDropDownItem {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class MedServiceSetHeaderRowItem implements IMedServiceSetHeaderRowItem {
  position?: number;
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  isHidden?: boolean;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
  medServices?: MedServiceDropDownItem[] | undefined;

  constructor(data?: IMedServiceSetHeaderRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.position = _data['position'];
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.isHidden = _data['isHidden'];
      this.description = _data['description'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
      if (Array.isArray(_data['medServices'])) {
        this.medServices = [] as any;
        for (let item of _data['medServices'])
          this.medServices!.push(MedServiceDropDownItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MedServiceSetHeaderRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceSetHeaderRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['position'] = this.position;
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['isHidden'] = this.isHidden;
    data['description'] = this.description;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    if (Array.isArray(this.medServices)) {
      data['medServices'] = [];
      for (let item of this.medServices)
        data['medServices'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IMedServiceSetHeaderRowItem {
  position?: number;
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  isHidden?: boolean;
  description?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
  medServices?: MedServiceDropDownItem[] | undefined;
}

export class MedServiceSetHeaderRowItemSearchResult implements IMedServiceSetHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: MedServiceSetHeaderRowItem[] | undefined;

  constructor(data?: IMedServiceSetHeaderRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results'])
          this.results!.push(MedServiceSetHeaderRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MedServiceSetHeaderRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceSetHeaderRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IMedServiceSetHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: MedServiceSetHeaderRowItem[] | undefined;
}

export class MedServiceSetMetadataUpdateRequest implements IMedServiceSetMetadataUpdateRequest {
  name?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IMedServiceSetMetadataUpdateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): MedServiceSetMetadataUpdateRequest {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceSetMetadataUpdateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IMedServiceSetMetadataUpdateRequest {
  name?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class MedServiceWithPrice implements IMedServiceWithPrice {
  id?: number;
  price?: number;

  constructor(data?: IMedServiceWithPrice) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.price = _data['price'];
    }
  }

  static fromJS(data: any): MedServiceWithPrice {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceWithPrice();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['price'] = this.price;
    return data;
  }
}

export interface IMedServiceWithPrice {
  id?: number;
  price?: number;
}

export class MedServiceWithPricesWebRequest implements IMedServiceWithPricesWebRequest {
  medServicesWithPrice?: MedServiceWithPrice[] | undefined;

  constructor(data?: IMedServiceWithPricesWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['medServicesWithPrice'])) {
        this.medServicesWithPrice = [] as any;
        for (let item of _data['medServicesWithPrice'])
          this.medServicesWithPrice!.push(MedServiceWithPrice.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MedServiceWithPricesWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new MedServiceWithPricesWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.medServicesWithPrice)) {
      data['medServicesWithPrice'] = [];
      for (let item of this.medServicesWithPrice)
        data['medServicesWithPrice'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IMedServiceWithPricesWebRequest {
  medServicesWithPrice?: MedServiceWithPrice[] | undefined;
}

export class NhfCode implements INhfCode {
  code?: string | undefined;
  name?: string | undefined;

  constructor(data?: INhfCode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): NhfCode {
    data = typeof data === 'object' ? data : {};
    let result = new NhfCode();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['name'] = this.name;
    return data;
  }
}

export interface INhfCode {
  code?: string | undefined;
  name?: string | undefined;
}

export enum NhfDataCodeGroupType {
  ServiceAccessLegalBase = 'ServiceAccessLegalBase',
  StatementProvisionType = 'StatementProvisionType',
  IdenityConfirmationType = 'IdenityConfirmationType',
  StatementMode = 'StatementMode',
  StatementType = 'StatementType',
  TitleType = 'TitleType',
  PrivildgedDocType = 'PrivildgedDocType',
  ServiceCode = 'ServiceCode',
  BeneficiaryCategoryType = 'BeneficiaryCategoryType',
  Institute = 'Institute',
  AdditionalCriteriaType = 'AdditionalCriteriaType',
}

export class PayerDropDownItem implements IPayerDropDownItem {
  id?: number;
  groupType?: PayerGroupType;
  name?: string | undefined;
  nameCode?: string | undefined;

  constructor(data?: IPayerDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.groupType = _data['groupType'];
      this.name = _data['name'];
      this.nameCode = _data['nameCode'];
    }
  }

  static fromJS(data: any): PayerDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new PayerDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['groupType'] = this.groupType;
    data['name'] = this.name;
    data['nameCode'] = this.nameCode;
    return data;
  }
}

export interface IPayerDropDownItem {
  id?: number;
  groupType?: PayerGroupType;
  name?: string | undefined;
  nameCode?: string | undefined;
}

export enum PayerGroupType {
  Private = 'Private',
  Nhf = 'Nhf',
  Invoice = 'Invoice',
  DateBooking = 'DateBooking',
  OnlineBooking = 'OnlineBooking',
  Unknown = 'Unknown',
}

export class PrivildgedDocumentType implements IPrivildgedDocumentType {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  category?: string | undefined;
  legalBasis?: string | undefined;

  constructor(data?: IPrivildgedDocumentType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.code = _data['code'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.category = _data['category'];
      this.legalBasis = _data['legalBasis'];
    }
  }

  static fromJS(data: any): PrivildgedDocumentType {
    data = typeof data === 'object' ? data : {};
    let result = new PrivildgedDocumentType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['name'] = this.name;
    data['description'] = this.description;
    data['category'] = this.category;
    data['legalBasis'] = this.legalBasis;
    return data;
  }
}

export interface IPrivildgedDocumentType {
  id?: number;
  code?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  category?: string | undefined;
  legalBasis?: string | undefined;
}

export class PublicHolidayDto implements IPublicHolidayDto {
  id?: number;
  year?: number;
  holidayDate?: Date;
  name?: string | undefined;
  namePl?: string | undefined;

  constructor(data?: IPublicHolidayDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.year = _data['year'];
      this.holidayDate = _data['holidayDate']
        ? new Date(_data['holidayDate'].toString())
        : (undefined as any);
      this.name = _data['name'];
      this.namePl = _data['namePl'];
    }
  }

  static fromJS(data: any): PublicHolidayDto {
    data = typeof data === 'object' ? data : {};
    let result = new PublicHolidayDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['year'] = this.year;
    data['holidayDate'] = this.holidayDate ? this.holidayDate.toISOString() : (undefined as any);
    data['name'] = this.name;
    data['namePl'] = this.namePl;
    return data;
  }
}

export interface IPublicHolidayDto {
  id?: number;
  year?: number;
  holidayDate?: Date;
  name?: string | undefined;
  namePl?: string | undefined;
}

export class RescheduleReasonDropDownItem implements IRescheduleReasonDropDownItem {
  id?: number;
  code?: number;
  reason?: string | undefined;
  isDescriptonRequired?: boolean;

  constructor(data?: IRescheduleReasonDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.code = _data['code'];
      this.reason = _data['reason'];
      this.isDescriptonRequired = _data['isDescriptonRequired'];
    }
  }

  static fromJS(data: any): RescheduleReasonDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new RescheduleReasonDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['reason'] = this.reason;
    data['isDescriptonRequired'] = this.isDescriptonRequired;
    return data;
  }
}

export interface IRescheduleReasonDropDownItem {
  id?: number;
  code?: number;
  reason?: string | undefined;
  isDescriptonRequired?: boolean;
}

export class Role implements IRole {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  defaultName?: string | undefined;
  priority?: number;

  constructor(data?: IRole) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.normalizedName = _data['normalizedName'];
      this.defaultName = _data['defaultName'];
      this.priority = _data['priority'];
    }
  }

  static fromJS(data: any): Role {
    data = typeof data === 'object' ? data : {};
    let result = new Role();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['normalizedName'] = this.normalizedName;
    data['defaultName'] = this.defaultName;
    data['priority'] = this.priority;
    return data;
  }
}

export interface IRole {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  defaultName?: string | undefined;
  priority?: number;
}

export class ServiceProviderDto implements IServiceProviderDto {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;

  constructor(data?: IServiceProviderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.regon = _data['regon'];
      this.code = _data['code'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.taxId = _data['taxId'];
      this.phone = _data['phone'];
      this.zip = _data['zip'];
      this.place = _data['place'];
      this.street = _data['street'];
      this.registryNumber = _data['registryNumber'];
    }
  }

  static fromJS(data: any): ServiceProviderDto {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceProviderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['regon'] = this.regon;
    data['code'] = this.code;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['name'] = this.name;
    data['description'] = this.description;
    data['taxId'] = this.taxId;
    data['phone'] = this.phone;
    data['zip'] = this.zip;
    data['place'] = this.place;
    data['street'] = this.street;
    data['registryNumber'] = this.registryNumber;
    return data;
  }
}

export interface IServiceProviderDto {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;
}

export class ServiceProviderHeaderRowItem implements IServiceProviderHeaderRowItem {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;
  isHidden?: boolean;

  constructor(data?: IServiceProviderHeaderRowItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.regon = _data['regon'];
      this.code = _data['code'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.taxId = _data['taxId'];
      this.phone = _data['phone'];
      this.zip = _data['zip'];
      this.place = _data['place'];
      this.street = _data['street'];
      this.registryNumber = _data['registryNumber'];
      this.isHidden = _data['isHidden'];
    }
  }

  static fromJS(data: any): ServiceProviderHeaderRowItem {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceProviderHeaderRowItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['regon'] = this.regon;
    data['code'] = this.code;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['name'] = this.name;
    data['description'] = this.description;
    data['taxId'] = this.taxId;
    data['phone'] = this.phone;
    data['zip'] = this.zip;
    data['place'] = this.place;
    data['street'] = this.street;
    data['registryNumber'] = this.registryNumber;
    data['isHidden'] = this.isHidden;
    return data;
  }
}

export interface IServiceProviderHeaderRowItem {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;
  isHidden?: boolean;
}

export class ServiceProviderHeaderRowItemSearchResult implements IServiceProviderHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: ServiceProviderHeaderRowItem[] | undefined;

  constructor(data?: IServiceProviderHeaderRowItemSearchResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPage = _data['currentPage'];
      this.total = _data['total'];
      if (Array.isArray(_data['results'])) {
        this.results = [] as any;
        for (let item of _data['results'])
          this.results!.push(ServiceProviderHeaderRowItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ServiceProviderHeaderRowItemSearchResult {
    data = typeof data === 'object' ? data : {};
    let result = new ServiceProviderHeaderRowItemSearchResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['total'] = this.total;
    if (Array.isArray(this.results)) {
      data['results'] = [];
      for (let item of this.results)
        data['results'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IServiceProviderHeaderRowItemSearchResult {
  currentPage?: number;
  total?: number;
  results?: ServiceProviderHeaderRowItem[] | undefined;
}

export enum ServiceProviderType {
  Nhf = 'Nhf',
  Private = 'Private',
}

export class SetIcdCodeMetaEntryWebRequest implements ISetIcdCodeMetaEntryWebRequest {
  type?: IcdCodeType;
  id?: number;
  metaKey?: string | undefined;
  entries?: IcdCodeMeta[] | undefined;

  constructor(data?: ISetIcdCodeMetaEntryWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.id = _data['id'];
      this.metaKey = _data['metaKey'];
      if (Array.isArray(_data['entries'])) {
        this.entries = [] as any;
        for (let item of _data['entries']) this.entries!.push(IcdCodeMeta.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SetIcdCodeMetaEntryWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SetIcdCodeMetaEntryWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['id'] = this.id;
    data['metaKey'] = this.metaKey;
    if (Array.isArray(this.entries)) {
      data['entries'] = [];
      for (let item of this.entries)
        data['entries'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISetIcdCodeMetaEntryWebRequest {
  type?: IcdCodeType;
  id?: number;
  metaKey?: string | undefined;
  entries?: IcdCodeMeta[] | undefined;
}

export class TerritoryCodeDropDownItem implements ITerritoryCodeDropDownItem {
  id?: number;
  voivodeshipCode?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  territoryTypeName?: string | undefined;
  territoryType?: number;
  code?: string | undefined;
  readonly displayName?: string | undefined;

  constructor(data?: ITerritoryCodeDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.voivodeshipCode = _data['voivodeshipCode'];
      this.countyName = _data['countyName'];
      this.communityName = _data['communityName'];
      this.territoryTypeName = _data['territoryTypeName'];
      this.territoryType = _data['territoryType'];
      this.code = _data['code'];
      (this as any).displayName = _data['displayName'];
    }
  }

  static fromJS(data: any): TerritoryCodeDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new TerritoryCodeDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['voivodeshipCode'] = this.voivodeshipCode;
    data['countyName'] = this.countyName;
    data['communityName'] = this.communityName;
    data['territoryTypeName'] = this.territoryTypeName;
    data['territoryType'] = this.territoryType;
    data['code'] = this.code;
    data['displayName'] = this.displayName;
    return data;
  }
}

export interface ITerritoryCodeDropDownItem {
  id?: number;
  voivodeshipCode?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  territoryTypeName?: string | undefined;
  territoryType?: number;
  code?: string | undefined;
  displayName?: string | undefined;
}

export class Unit implements IUnit {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  isReadOnly?: boolean;

  constructor(data?: IUnit) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.normalizedName = _data['normalizedName'];
      this.zip = _data['zip'];
      this.city = _data['city'];
      this.street = _data['street'];
      this.houseNo = _data['houseNo'];
      this.flatNo = _data['flatNo'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.themeInfo = _data['themeInfo'];
      this.description = _data['description'];
      this.isReadOnly = _data['isReadOnly'];
    }
  }

  static fromJS(data: any): Unit {
    data = typeof data === 'object' ? data : {};
    let result = new Unit();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['normalizedName'] = this.normalizedName;
    data['zip'] = this.zip;
    data['city'] = this.city;
    data['street'] = this.street;
    data['houseNo'] = this.houseNo;
    data['flatNo'] = this.flatNo;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['themeInfo'] = this.themeInfo;
    data['description'] = this.description;
    data['isReadOnly'] = this.isReadOnly;
    return data;
  }
}

export interface IUnit {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  houseNo?: string | undefined;
  flatNo?: string | undefined;
  serviceProviderCode?: string | undefined;
  nhfBranchCode?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  isReadOnly?: boolean;
}

export class UnitHeader implements IUnitHeader {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  nhfBranchCode?: string | undefined;
  nhfBranchName?: string | undefined;
  serviceProviderCode?: string | undefined;
  isReadOnly?: boolean;
  hasBookingConfig?: boolean;
  divisionHeaders?: DivisionHeader[] | undefined;

  constructor(data?: IUnitHeader) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.normalizedName = _data['normalizedName'];
      this.themeInfo = _data['themeInfo'];
      this.description = _data['description'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.nhfBranchName = _data['nhfBranchName'];
      this.serviceProviderCode = _data['serviceProviderCode'];
      this.isReadOnly = _data['isReadOnly'];
      this.hasBookingConfig = _data['hasBookingConfig'];
      if (Array.isArray(_data['divisionHeaders'])) {
        this.divisionHeaders = [] as any;
        for (let item of _data['divisionHeaders'])
          this.divisionHeaders!.push(DivisionHeader.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UnitHeader {
    data = typeof data === 'object' ? data : {};
    let result = new UnitHeader();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['normalizedName'] = this.normalizedName;
    data['themeInfo'] = this.themeInfo;
    data['description'] = this.description;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['nhfBranchName'] = this.nhfBranchName;
    data['serviceProviderCode'] = this.serviceProviderCode;
    data['isReadOnly'] = this.isReadOnly;
    data['hasBookingConfig'] = this.hasBookingConfig;
    if (Array.isArray(this.divisionHeaders)) {
      data['divisionHeaders'] = [];
      for (let item of this.divisionHeaders)
        data['divisionHeaders'].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IUnitHeader {
  id?: number;
  name?: string | undefined;
  normalizedName?: string | undefined;
  themeInfo?: string | undefined;
  description?: string | undefined;
  nhfBranchCode?: string | undefined;
  nhfBranchName?: string | undefined;
  serviceProviderCode?: string | undefined;
  isReadOnly?: boolean;
  hasBookingConfig?: boolean;
  divisionHeaders?: DivisionHeader[] | undefined;
}

export class UpdateMedServiceWebRequest implements IUpdateMedServiceWebRequest {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;

  constructor(data?: IUpdateMedServiceWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.name = _data['name'];
      this.icd9Code = _data['icd9Code'];
      this.code = _data['code'];
      this.bodyAreaCode = _data['bodyAreaCode'];
      this.nhfPoints = _data['nhfPoints'];
      this.withContrast = _data['withContrast'];
      this.withSpine = _data['withSpine'];
      this.withPrePostContrast = _data['withPrePostContrast'];
      this.defaultEtcInMinutes = _data['defaultEtcInMinutes'];
    }
  }

  static fromJS(data: any): UpdateMedServiceWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateMedServiceWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['name'] = this.name;
    data['icd9Code'] = this.icd9Code;
    data['code'] = this.code;
    data['bodyAreaCode'] = this.bodyAreaCode;
    data['nhfPoints'] = this.nhfPoints;
    data['withContrast'] = this.withContrast;
    data['withSpine'] = this.withSpine;
    data['withPrePostContrast'] = this.withPrePostContrast;
    data['defaultEtcInMinutes'] = this.defaultEtcInMinutes;
    return data;
  }
}

export interface IUpdateMedServiceWebRequest {
  id?: number;
  type?: DeviceTypes;
  name?: string | undefined;
  icd9Code?: string | undefined;
  code?: string | undefined;
  bodyAreaCode?: string | undefined;
  nhfPoints?: string | undefined;
  withContrast?: string | undefined;
  withSpine?: string | undefined;
  withPrePostContrast?: string | undefined;
  defaultEtcInMinutes?: string | undefined;
}

export class UpdateServiceProviderWebRequest implements IUpdateServiceProviderWebRequest {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;

  constructor(data?: IUpdateServiceProviderWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.type = _data['type'];
      this.regon = _data['regon'];
      this.code = _data['code'];
      this.nhfBranchCode = _data['nhfBranchCode'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.taxId = _data['taxId'];
      this.phone = _data['phone'];
      this.zip = _data['zip'];
      this.place = _data['place'];
      this.street = _data['street'];
      this.registryNumber = _data['registryNumber'];
    }
  }

  static fromJS(data: any): UpdateServiceProviderWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateServiceProviderWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['type'] = this.type;
    data['regon'] = this.regon;
    data['code'] = this.code;
    data['nhfBranchCode'] = this.nhfBranchCode;
    data['name'] = this.name;
    data['description'] = this.description;
    data['taxId'] = this.taxId;
    data['phone'] = this.phone;
    data['zip'] = this.zip;
    data['place'] = this.place;
    data['street'] = this.street;
    data['registryNumber'] = this.registryNumber;
    return data;
  }
}

export interface IUpdateServiceProviderWebRequest {
  id?: number;
  type?: ServiceProviderType;
  regon?: string | undefined;
  code?: string | undefined;
  nhfBranchCode?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  taxId?: string | undefined;
  phone?: string | undefined;
  zip?: string | undefined;
  place?: string | undefined;
  street?: string | undefined;
  registryNumber?: string | undefined;
}

export class VerifyIcdCodeWebRequest implements IVerifyIcdCodeWebRequest {
  type?: IcdCodeType;
  id?: number;
  isVerified?: boolean;

  constructor(data?: IVerifyIcdCodeWebRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.id = _data['id'];
      this.isVerified = _data['isVerified'];
    }
  }

  static fromJS(data: any): VerifyIcdCodeWebRequest {
    data = typeof data === 'object' ? data : {};
    let result = new VerifyIcdCodeWebRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['id'] = this.id;
    data['isVerified'] = this.isVerified;
    return data;
  }
}

export interface IVerifyIcdCodeWebRequest {
  type?: IcdCodeType;
  id?: number;
  isVerified?: boolean;
}

export class ZipCodeDistinctDropDownItem implements IZipCodeDistinctDropDownItem {
  zip?: string | undefined;
  city?: string | undefined;
  voivodName?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  street?: string | undefined;

  constructor(data?: IZipCodeDistinctDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.zip = _data['zip'];
      this.city = _data['city'];
      this.voivodName = _data['voivodName'];
      this.countyName = _data['countyName'];
      this.communityName = _data['communityName'];
      this.street = _data['street'];
    }
  }

  static fromJS(data: any): ZipCodeDistinctDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new ZipCodeDistinctDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['zip'] = this.zip;
    data['city'] = this.city;
    data['voivodName'] = this.voivodName;
    data['countyName'] = this.countyName;
    data['communityName'] = this.communityName;
    data['street'] = this.street;
    return data;
  }
}

export interface IZipCodeDistinctDropDownItem {
  zip?: string | undefined;
  city?: string | undefined;
  voivodName?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  street?: string | undefined;
}

export class ZipCodeDropDownItem implements IZipCodeDropDownItem {
  id?: number;
  zip?: string | undefined;
  city?: string | undefined;
  voivodName?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  street?: string | undefined;
  district?: string | undefined;
  numbers?: string | undefined;

  constructor(data?: IZipCodeDropDownItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.zip = _data['zip'];
      this.city = _data['city'];
      this.voivodName = _data['voivodName'];
      this.countyName = _data['countyName'];
      this.communityName = _data['communityName'];
      this.street = _data['street'];
      this.district = _data['district'];
      this.numbers = _data['numbers'];
    }
  }

  static fromJS(data: any): ZipCodeDropDownItem {
    data = typeof data === 'object' ? data : {};
    let result = new ZipCodeDropDownItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['zip'] = this.zip;
    data['city'] = this.city;
    data['voivodName'] = this.voivodName;
    data['countyName'] = this.countyName;
    data['communityName'] = this.communityName;
    data['street'] = this.street;
    data['district'] = this.district;
    data['numbers'] = this.numbers;
    return data;
  }
}

export interface IZipCodeDropDownItem {
  id?: number;
  zip?: string | undefined;
  city?: string | undefined;
  voivodName?: string | undefined;
  countyName?: string | undefined;
  communityName?: string | undefined;
  street?: string | undefined;
  district?: string | undefined;
  numbers?: string | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
